import Link from 'next/link';

import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';

import { helper } from '@myrealtrip/frontend-weblog';
import { media } from '@myrealtrip/modash';
import { IcoChevronRight, IcoInformation } from '@myrealtrip/web-icons';
import { Text } from '@myrealtrip/web-ui';

import { WeblogEventName, WeblogPageCategory, WeblogScreenName } from '~constants/weblog';
import { useDetermineMobile, useWebView } from '@myrealtrip/device-detect';

const { sendClickLog } = helper;

const PassBanner = () => {
  const isMobile = useDetermineMobile();
  const { isWebView } = useWebView();
  const { colors } = useTheme();

  const iconSize = isMobile ? 16 : 20;
  const typography = isMobile ? 'paragraphBold13' : 'headlineNormal15';

  const handleClickLink = () => {
    sendClickLog({
      pageCategory: WeblogPageCategory.EUROPE_TRAIN_TICKET_MAIN,
      screenName: WeblogScreenName.EUROPE_TRAIN_TICKET_MAIN,
      eventName: WeblogEventName.FIND_MY_PASS,
      itemKind: 'button',
      itemName: '나에게 맞는 패스 찾기',
    });
  };

  const LINK = 'https://22kucocobzm.typeform.com/to/bOGqRPsg';

  return (
    <StyledLink
      href={isWebView ? `mrt://externalweb?url=${encodeURIComponent(LINK)}` : LINK}
      target="_blank"
      onClick={handleClickLink}
    >
      <Inner>
        <TextWrapper>
          <IcoInformation color={colors.blue.s700} size={iconSize} />
          <Text color={colors.blue.s700} typography={typography}>
            나에게 맞는 패스 찾기
          </Text>
        </TextWrapper>
        <IcoChevronRight color={colors.blue.s700} size={iconSize} />
      </Inner>
    </StyledLink>
  );
};

export default PassBanner;

const StyledLink = styled(Link)`
  background-color: #f5f9ff;
`;

const Inner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;

  ${media.minMobile} {
    padding: 12px 16px 12px 12px;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;
